import React, { useCallback, useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { LinearProgress, Switch } from "@mui/material";
import CustomNoRowsOverlay from "../utils/styles"; // Ensure this is properly imported
import ActionButton from "../components/Forms/ActionButton";
import { toast } from "react-toastify";
import * as api from "../redux/api";
import { reactIcons } from "../utils/icons";
import ChangeUserPassword from "../components/modals/ChangeUserPassword";
import UserKYCTable from "../components/modals/UserKYC";
// import { CopyToClipboard } from "react-copy-to-clipboard";
// import AddUser from "../components/modals/AddUser";
import { useSelector } from "react-redux";
// import { getAuth } from "../redux/features/authSlice";
import AddBuyerModal from "../components/modals/AddBuyerModal";
import { debounce } from "lodash";
import CashPayoutModal from "../components/modals/CashPayoutModal";
import EditUser from "../components/modals/EditUser";
import AddAssestMnager from "../components/modals/AddAssestMnager";

const Pool = () => {
  const [buyerId, setBuyerId] = useState(null);
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState({});
  const [editOpen, setEditOpen] = useState(false);
  const [buyOpen, setBuyOpen] = useState(false);
  const [cashPayoutOpen, setCashPayoutOpen] = useState(false);
  const [queryParams, setQueryParams] = useState({});
  const [userData, setUserData] = React.useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [rows, setRows] = useState([]);
  const [activeType, setActiveType] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [openUserKYCTable, setOpenUserKYCTable] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 8
  });
  const [rowCountState, setRowCountState] = useState(0);

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    setActiveType(selectedValue);
    let queryParam = {};

    switch (selectedValue) {
      case "Active":
        queryParam = {
          status: "Active"
        };
        break;
      case "Verified":
        queryParam = { isVerified: true };
        break;
      case "NotVerified":
        queryParam = { isVerified: false };
        break;
      case "Blocked":
        queryParam = { status: "Blocked" };
        break;
      case "Suspend":
        queryParam = { status: "Suspend" };
        break;
      default:
        queryParam = {};
    }

    setQueryParams(queryParam);
  };

  const handleViewKYC = (data) => {
    setSelectedUser(data);
    setOpenUserKYCTable(true);
  };

  const options = (userData) => {
    const userId = userData.id;
    const blockLabel = userData.status === "Blocked" ? "Unblock" : "Block";
    const suspendLabel =
      userData.status === "Suspended" ? "Reinstate" : "Suspend";
    return [
      {
        label: "Change Password",
        onClick: () => {
          setOpen(true);
          setUserData(userId);
        }
      },
      {
        label: "Edit User",
        onClick: () => {
          setEditOpen(true);
          setData(userData);
        }
      },

      { label: "View KYC Document", onClick: () => handleViewKYC(userData) },
      {
        label: blockLabel,
        onClick: () => handleBlockAndSuspend(userId, blockLabel)
      },
      {
        label: suspendLabel,
        onClick: () => handleBlockAndSuspend(userId, suspendLabel)
      },
      {
        label: "Purchase",
        onClick: () => handleBuy(userId)
      },
      {
        label: "Cash Payout",
        onClick: () => {
          setCashPayoutOpen(true);
          setUserData(userId);
        }
      }
    ];
  };
  const handleBuy = (id) => {
    setBuyOpen(true);
    setBuyerId(id);
  };

  let columns = [
    {
      field: "_id",
      headerName: "S.No.",
      type: "number",
      headerAlign: "center",
      align: "center",
      width: 100
    },
    {
      field: "poolName",
      headerName: "PoolName",
      type: "string",
      flex: 3
    },
    {
      field: "poolType",
      headerName: "PoolType",
      type: "string",
      flex: 3,
      valueFormatter: (params) => (params.value ? params.value : "-")
    },
    {
      field: "totalpool",
      headerName: "TotalPool",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 2,
      valueFormatter: (params) => (params.value ? params.value : "-")
    },
    {
      field: "initialPoolValue",
      headerName: "InitialPoolValue",
      type: "string",
      flex: 3,
      valueFormatter: (params) => (params.value ? params.value : "-")
    },
    // {
    //   field: "walletAddress",
    //   headerName: "Wallet Address",
    //   type: "string",
    //   flex: 3,
    //   renderCell: (params) => {
    //     return (
    //       <div className="flex gap-1 items-center">
    //         <div>
    //           {params.value ? (
    //             <div className="flex gap-2 items-center" title={params.value}>
    //               {params.value.slice(0, 4) +
    //                 "..." +
    //                 params.value.slice(40, 42)}{" "}
    //               <span>
    //                 <CopyToClipboard text={params.value} onCopy={handleCopy}>
    //                   <button className="cursor-pointer">
    //                     {reactIcons.copy}
    //                   </button>
    //                 </CopyToClipboard>
    //               </span>
    //             </div>
    //           ) : (
    //             "-"
    //           )}
    //         </div>
    //       </div>
    //     );
    //   }
    // },
    {
      field: "isVerified",
      headerName: "Verified",
      type: "boolean",
      flex: 2,
      renderCell: (params) => (
        <Switch
          checked={params.value}
          color="default"
          sx={{
            "& .MuiSwitch-thumb": {
              backgroundColor: "green" // Thumb (circle) color
            },
            "& .MuiSwitch-track": {
              backgroundColor: "white", // Track (background) color
              opacity: 1 // Ensure full color visibility
            },
            "& .Mui-checked .MuiSwitch-thumb": {
              backgroundColor: "green" // Thumb remains white when checked
            },
            "& .Mui-checked + .MuiSwitch-track": {
              backgroundColor: "white", // Track remains white when checked
              opacity: 2
            }
          }}
        />
      )
    },
    {
      field: "isPublic",
      headerName: "Public",
      type: "string",
      flex: 2
    },
    {
      field: "tokenized",
      headerName: "Tokenized",
      type: "string",
      flex: 2
    },
    {
      field: "isDocuments",
      headerName: "Documents",
      type: "string",
      flex: 2
    },
    {
      field: "poolCategory",
      headerName: "PoolCategory",
      type: "string",
      flex: 2
    },
    {
      field: "poolStatus",
      headerName: "PoolStatus",
      type: "string",
      flex: 2,
      valueFormatter: (params) => (params.value ? params.value : "-")
    },
    {
      field: "action",
      headerName: "Action",
      type: "actions",
      flex: 2,
      getActions: (params) => {
        return [
          <ActionButton key={params.row.id} options={options(params.row)} />
        ];
      }
    }
  ];
  const getUserData = async () => {
    setIsLoading(true);
    const response = await api.getPool(
      paginationModel.page,
      searchText,
      queryParams
    );
    console.log(response, "response");
    const { data, status } = response;
    if (status >= 200 && status < 300) {
      setIsLoading(false);
      setRowCountState(data.count);
      setRows(
        data.data.map((item, index) => {
          const kycStatus = `${item?.isVerified ? "Verified" : "Not Verified"}`;
          const address =
            `${item?.meta?.address_line_1 ?? ""}${
              item?.meta?.address_line_2
                ? ", " + item?.meta?.address_line_2
                : ""
            }${item?.meta?.city ? ", " + item?.meta?.city : ""}${
              item?.meta?.state ? ", " + item?.meta?.state : ""
            }` ?? " ";
          return {
            ...item,
            name: item?.firstname + " " + item?.lastname,
            email: item?.email === null ? "N/A" : item?.email,
            mobile: item?.mobile,
            address: address === "" ? "N/A" : address,
            walletAddress: item?.meta?.walletAddress,
            status: item?.status === "Suspend" ? "Suspended" : item?.status,
            kycStatus: kycStatus,
            // status: item?.isVerified ? "Verified" : "Not Verified",
            _id: 8 * paginationModel.page + index + 1,
            id: item?.id,
            isBlock: item?.isBlock,
            isSuspend: item?.isSuspend,
            aadhaarNumber: item?.meta?.aadhaarNumber,
            panCardNumber: item?.meta?.panCardNumber
          };
        })
      );
    } else {
      setIsLoading(false);
      toast.error(data.message);
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedFetchUsers = useCallback(
    debounce(() => getUserData(), 500), // 500ms debounce delay
    [paginationModel, rowCountState, setRowCountState, searchText, queryParams]
  );

  useEffect(() => {
    debouncedFetchUsers();
    return () => {
      debouncedFetchUsers.cancel();
    };
  }, [debouncedFetchUsers]);

  const handleBlockAndSuspend = async (id, blockLabel) => {
    setIsLoading(true);
    try {
      const res = await api.blockUserAndSuspendById(id, blockLabel);
      if (res.status === 200 || res.status === 201) {
        setIsLoading(false);
        toast.success(`${blockLabel} Successfully`);
        debouncedFetchUsers();
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      toast.error(error.message);
      setIsLoading(false);
    }
  };

  // const link = `${
  //   process.env.REACT_APP_REFERRAL_LINK
  // }?UTH_sponsor=${encodeURIComponent(user && user?.meta?.referralCode)}`;
  // const handleCopyLink = () => {
  //   toast.success("Copied Successfully");
  // };

  return (
    <>
      <div className="w-full mt-10 data-grid">
        <div className="mb-6">
          <div className="flex justify-between items-center">
            <h4 className="text-white">Pool</h4>
            <div className="flex flex-col justify-end items-end gap-2">
              <div className="flex gap-2">
                <div className="relative">
                  <input
                    className="w-[250px] h-[45px] bg-transparent text-white"
                    type="text"
                    value={searchText}
                    placeholder="Search by name, email"
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <span className="absolute text-18 top-[calc(50%-9px)] right-2">
                    {reactIcons.search}
                  </span>
                </div>
                <div className="form-select-custom">
                  <select
                    className="min-w-[150px] w-full h-[45px] bg-[#093f27]"
                    name="usersType"
                    id="usersType"
                    value={activeType}
                    onChange={handleSelectChange}
                  >
                    <option value="" disabled selected>
                      Status
                    </option>
                    <option value="">All</option>
                    <option value="Active">Active</option>
                    <option value="Verified">Verified</option>
                    <option value="NotVerified">Not Verified</option>
                    <option value="Blocked">Blocked</option>
                    <option value="Suspend">Suspend</option>
                  </select>
                  <span className="ay-center right-2 text-zinc-500 text-[20px] pointer-events-none ">
                    {reactIcons.arrowDown}
                  </span>
                </div>
                {/* <div className="form-select-custom">
                  <select
                    className="min-w-[150px] w-full h-[45px] bg-white"
                    name="userPaid"
                    id="userPaid"
                    value={userType}
                    onChange={handleSelectPaid}
                  >
                    <option value="" disabled selected>
                      Type
                    </option>
                    <option value="">All</option>
                    <option value="Paid">Paid</option>
                    <option value="Unpaid">Unpaid</option>
                  </select>
                  <span className="ay-center right-2 text-zinc-500 text-[20px] pointer-events-none ">
                    {reactIcons.arrowDown}
                  </span>
                </div> */}
              </div>
              <div className="flex gap-2 items-center">
                {/* <p className="text-black mr-2">Referral Link: </p>
                <CopyToClipboard text={link} onCopy={handleCopyLink}>
                  <span
                    className="border border-gray-300 rounded-md p-2 gap-2 cursor-pointer flex items-center h-[45px] text[13px]"
                    title={link}
                  >
                    {link.slice(0, 35) + "..." || "N/A"}
                    {reactIcons.copy}
                  </span>
                </CopyToClipboard> */}
                <button
                  type="button"
                  className="btn btn-primary flex justify-between items-center gap-2"
                  onClick={() => setIsOpen(true)}
                >
                  Add Pool
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="h-[600px] w-full mt-4  bg-[#00341D]">
          <DataGrid
            loading={isLoading}
            rows={rows}
            getRowId={(row) => row._id} // Ensure _id is unique
            getEstimatedRowHeight={() => 52}
            columns={columns}
            initialState={{
              paginationModel: {
                pageSize: 8
              }
            }}
            rowCount={rowCountState} // Ensure this is updated with total row count
            pageSizeOptions={[8]}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={setPaginationModel}
            slots={{
              loadingOverlay: LinearProgress,
              noRowsOverlay: CustomNoRowsOverlay
            }}
            disableColumnMenu
            disableRowSelectionOnClick
            sx={{
              "& .MuiDataGrid-row:hover": {
                cursor: "default"
              }
            }}
          />
        </div>
      </div>
      <ChangeUserPassword
        open={open}
        handleClose={() => {
          setOpen(false);
          debouncedFetchUsers();
        }}
        userData={userData}
      />
      {openUserKYCTable && (
        <UserKYCTable
          open={openUserKYCTable}
          handleClose={() => {
            setOpenUserKYCTable(false);
            setSelectedUser(null);
          }}
          userData={selectedUser}
        />
      )}
      {isOpen && (
        <AddAssestMnager
          handleClose={() => {
            setIsOpen(false);
            debouncedFetchUsers();
          }}
          open={isOpen}
          user={user}
        />
      )}
      {editOpen && (
        <EditUser
          handleClose={() => {
            setEditOpen(false);
            debouncedFetchUsers();
          }}
          open={editOpen}
          user={user}
          data={data}
        />
      )}
      {buyOpen && (
        <AddBuyerModal
          open={buyOpen}
          handleClose={() => {
            setBuyOpen(false);
            debouncedFetchUsers();
          }}
          buyerId={buyerId}
        />
      )}
      {cashPayoutOpen && (
        <CashPayoutModal
          open={cashPayoutOpen}
          handleClose={() => {
            setCashPayoutOpen(false);
            debouncedFetchUsers();
          }}
          userData={userData}
        />
      )}
    </>
  );
};

export default Pool;
